import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import getDeliveryAddressAttribute from '../../../delivery-address/getDeliveryAddressAttribute';
import {isGuest} from '../../../selectors/selectors';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';
import Spinner from '../../ui/Spinner';
import SuccessIcon from '../../ui/svg/success.svg';
import PudoSavedAddressText from './PudoSavedAddressText';

export function PudoSavedAddress(props) {
  const handleChange = () => {
    props.updateSelectedCollectionPoint(props.index);
    try {
      doMetric('selectDeliveryAddress', props.getDeliveryAddressAttribute());
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <div id={`PudoSavedAddress-${props.index}`}>
      {props.isCollectionPointLoading && (
        <div className="PudoSavedAddress__animation">
          <img className="PudoSavedAddress__successIcon" src={SuccessIcon} alt="" />
          <span className="PudoSavedAddress__spinnerWrapper"><Spinner size="extra-small" /></span>
        </div>
      )}
      <div
        className={`PudoSavedAddress__container ${props.isCollectionPointLoading
          ? 'PudoSavedAddress__container--loading'
          : ''}`}
      >
        {!props.isGuest && (
          <input
            disabled={props.disabled ? 'disabled' : ''}
            id={props.index}
            checked={props.checked}
            type="radio"
            name="PudoSavedAddress"
            value={props.address.addressId}
            className={`PudoSavedAddress__radio ${props.radioInputHidden ? 'PudoSavedAddress__radio--hidden' : ''}`}
            onChange={handleChange}
            data-test="PudoSavedAddress__radio-input"
          />
        )}
        <PudoSavedAddressText
          id={props.index}
          address={props.address}
          paddingLeft={!props.radioInputHidden}
        />
      </div>
    </div>
  );
}

PudoSavedAddress.propTypes = {
  index: PropTypes.number.isRequired,
  address: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  isCollectionPointLoading: PropTypes.bool,
  lastIndex: PropTypes.number,
  isGuest: PropTypes.bool.isRequired,
  radioInputHidden: PropTypes.bool,
  updateSelectedCollectionPoint: PropTypes.func.isRequired,
  getDeliveryAddressAttribute: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  const isCollectionPointLoading = state.pudo.collectionPointLoading && (ownProps.lastIndex - 1 === ownProps.index);
  return {
    pudo: state.pudo,
    isCollectionPointLoading,
    isGuest: isGuest(state),
  };
}

PudoSavedAddress.defaultProps = {
  radioInputHidden: false,
};

export default connect(mapStateToProps, {getDeliveryAddressAttribute})(PudoSavedAddress);
